import angular from "angular"

FormularioEditarRolesController.$inject = [
  "$scope",
  "$mdDialog",
  "GroupService",
  "saveCallback",
  "models"
]
function FormularioEditarRolesController($scope, $mdDialog, GroupService, saveCallback, models) {
  var self = $scope
  self.rol = GroupService.get({ id: models[0].id }, function() {
    self.name = self.rol.name
  })

  self.isLoading = false

  self.confirm = function() {
    self.rol.pk = self.rol.id
    self.rol.name = self.name

    saveCallback(self.rol)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

angular
  .module("appModule")
  .controller("FormularioEditarRolesController", FormularioEditarRolesController)
